import React, { MouseEvent, useState, useEffect } from 'react';
import '../../styles/ChatHeader.css';
import {
	Box,
	Divider,
	IconButton,
	Menu,
	MenuItem,
	Stack,
	Tooltip,
	Typography,
	Popover,
} from '@mui/material';
import { ArrowBack, MoreVert, Search } from '@mui/icons-material';
import {
	EVENT_TOPIC_CONTACT_DETAILS_VISIBILITY,
	EVENT_TOPIC_FORCE_REFRESH_CHAT,
	EVENT_TOPIC_SEARCH_MESSAGES_VISIBILITY,
	RESTAURANT,
} from '@src/Constants';
import PubSub from 'pubsub-js';
import { addPlus } from '@src/helpers/PhoneNumberHelper';
import WarningIcon from '@mui/icons-material/Warning';
import { isMobileOnly } from 'react-device-detect';
import {
	getDisplayAssignmentAndTaggingHistory,
	setDisplayAssignmentAndTaggingHistory,
} from '@src/helpers/StorageHelper';
import { useTranslation } from 'react-i18next';
import PrintMessage from '../PrintMessage';
import CustomAvatar from '@src/components/CustomAvatar';
import AssigneeChip from '@src/components/AssigneeChip';
import styles from './ChatHeader.module.css';
import useChatAssignmentAPI from '@src/hooks/api/useChatAssignmentAPI';
import classNames from 'classnames/bind';
import PersonModel from '@src/api/models/PersonModel';
import ChatModel from '@src/api/models/ChatModel';
import CustomButton from '../CustomButton/CustomButton';
import { useAppDispatch, useAppSelector } from '@src/store/hooks';
import { ApplicationContext } from '@src/contexts/ApplicationContext';
import { AxiosError, AxiosResponse } from 'axios';
import CustomModal from '../CustomModal';
import StartNewOrder from '../StartNewOrder/StartNewOrder';
import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
import {
	EditOrder,
	LockIconSmall,
	OrderBookIcon,
	OrderCartIcon,
	OrderCartIcon2,
	ShoppingCartIcon,
	ShowMoreIcon,
} from '../Icons';
import CustomAlert from '../CustomAlert/CustomAlert';
import CartComponent from '../CartComponent/CartComponent';
import { styled } from '@mui/system';
import { setIsDrawerOpen } from '@src/store/reducers/UIReducer';
import CustomDrawer from '../CustomDrawer/CustomDrawer';
import { CustomAlertType } from '@src/pages/Catalogs';
import usePermission from '@src/hooks/usePermission';
import { ALL_PERMISSION_MAP } from '@src/helpers/Permission';
import CustomTooltip from '../CustomTootip/CustomTooltip';
import { IsMobileWidth } from '../MediaQueryUtils';
const cx = classNames.bind(styles);

const startNewOrderModalStyles = {
	maxHeight: 'auto',
	position: 'absolute',
	maxWidth: 'auto',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	backgroundColor: 'background.paper',
	borderRadius: '4px',
	boxShadow: '24px',
	'@media (max-width: 978px)': {
		width: '90%',
		maxWidth: '90%',
		height: '645px',
		maxHeight: '645px',
	},
};
const orderSummaryModalStyles = {
	maxHeight: 'auto',
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	backgroundColor: 'background.paper',
	borderRadius: '4px',
	boxShadow: '24px',
	'@media (max-width: 768px)': {
		width: '90%',
		maxWidth: '90%',
		height: '645px',
		maxHeight: '645px',
	},
};

const CartItemsCount = styled('div')({
	position: 'absolute',
	background: '#FFBE00',
	fontSize: '8.5px',
	width: 'auto',
	minWidth: '14px',
	height: '14px',
	display: 'flex',
	alignItems: 'center',
	color: '#1A1D1F',
	fontWeight: '700',
	fontFamily: 'Nunito Sans',
	justifyContent: 'center',
	borderRadius: '50%',
	top: '6px',
	right: '5px',
	border: '0.5px solid #F7F5F4',
});

const IconContainer = styled('div')({
	display: 'flex',
	alignItems: 'center',
	gap: '10px',
});

interface Props {
	chat?: ChatModel;
	person?: PersonModel;
	contactProvidersData: any;
	retrieveContactData: (waId: string) => void;
	isChatOnly: boolean | Number;
	setChatAssignmentVisible: (isVisible: boolean) => void;
	setChatTagsVisible: (isVisible: boolean) => void;
	closeChat: () => void;
	hasFailedMessages: boolean;
	waId: string;
	setOrderBook?: (data: boolean) => void;
	setDrawerOpen?: (data: boolean) => void;
	displayCustomError: any;
	setOpenModal: any;
	setWidth: any;
	cartData: any;
	setShowCartModal: any;
	loadingCart: boolean;
	rewardsInfo: any;
	creditInfo: any;
}

function RenderRewardAmountAvailable({ rewardsInfo, creditInfo }: any) {
	const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

	const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handlePopoverClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);
	if (!rewardsInfo) return null;
	const { total } = rewardsInfo || {};
	const totalAsInt = parseInt(total || 0);

	const { creditAvailable, isActive } = creditInfo || {};
	const creditRemaining =
		creditAvailable >= 0 ? (
			<span style={{ color: 'green' }}>Rs {parseInt(creditAvailable)} available</span>
		) : (
			<span style={{ color: 'red' }}>Exceeded</span>
		);

	const CreditRemainingComp = isActive ? (
		<Typography fontSize={14}>Credit : {creditRemaining}</Typography>
	) : null;
	return (
		<>
			<Stack
				direction={'row'}
				alignItems={'center'}
				gap={1}
				onMouseEnter={handlePopoverOpen}
				onMouseLeave={handlePopoverClose}
			>
				<LocalPoliceIcon sx={{ color: '#FFBE00' }} />
			</Stack>
			<Popover
				id="mouse-over-popover"
				sx={{ pointerEvents: 'none' }}
				open={open}
				anchorEl={anchorEl}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				onClose={handlePopoverClose}
				disableRestoreFocus
				hideBackdrop
			>
				<Stack direction={'column'} gap={1} p={2}>
					<Typography fontSize={14}>
						Rewards : <span style={{ color: 'green' }}>Rs {totalAsInt} available</span>
					</Typography>
					{CreditRemainingComp}
				</Stack>
			</Popover>
		</>
	);
}

const ChatHeader: React.FC<Props> = ({
	chat,
	person,
	contactProvidersData,
	retrieveContactData,
	isChatOnly,
	setChatAssignmentVisible,
	setChatTagsVisible,
	closeChat,
	setOrderBook,
	setDrawerOpen,
	hasFailedMessages,
	waId,
	displayCustomError,
	setOpenModal,
	setWidth,
	cartData,
	setShowCartModal,
	loadingCart,
	rewardsInfo,
	creditInfo,
}) => {
	const { t } = useTranslation();
	const isMobileWidth = IsMobileWidth();
	const [anchorEl, setAnchorEl] = useState<Element>();

	const [apiCall, setApiCall] = useState(false);
	const { partialUpdateChatAssignment } = useChatAssignmentAPI();
	const currentUser: any = useAppSelector((state) => state?.currentUser?.value);

	const checkPermission = usePermission();

	const isRestaurant = currentUser?.type?.toLowerCase() === RESTAURANT;

	const canCreateOrder = checkPermission(ALL_PERMISSION_MAP?.GENERAL?.ORDER?.CREATE, waId);
	const canCreateOrderBook = checkPermission(
		ALL_PERMISSION_MAP?.RESTAURANT?.ORDER_BOOK?.CREATE,
		waId
	);
	const canViewCart = checkPermission(ALL_PERMISSION_MAP?.RESTAURANT?.CART?.VIEW, waId);

	//Mobile Screen States
	const [windowDimensions, setWindowDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight,
	});

	const updateWindowDimensions = () => {
		setWindowDimensions({
			width: window.innerWidth,
			height: window.innerHeight,
		});
	};

	const orderButton = () => {
		const disableOne = (title: string) => {
			return (
				<CustomTooltip title={title} placement="bottom">
					<span>
						<CustomButton
							StartIcon={<LockIconSmall stroke="#acacac" />}
							title="Start Order"
							handleClick={() => {}}
							color="primary"
							heightVariant="medium"
							styles={{ height: '36px' }}
							disabled={true}
						/>
					</span>
				</CustomTooltip>
			);
		};
		const enableOne = () => {
			return (
				<CustomButton
					title="Start Order"
					handleClick={() => {
						setOpenModal(true);
						setWidth('1118px');
					}}
					color="primary"
					heightVariant="medium"
					styles={{ height: '36px' }}
					disabled={cartData?.cart?.length || loadingCart}
				/>
			);
		};

		if (canCreateOrder) {
			if (isRestaurant) {
				return enableOne();
			} else {
				if (chat?.supplierToCreateOrder) {
					return enableOne();
				} else {
					return disableOne('You are not allowed to create order');
				}
			}
		} else {
			return disableOne(
				'You do not have permission to create an order. Contact an administrator to get permission.'
			);
		}
	};

	const cartIconButton = () => {
		if (canViewCart) {
			if (cartData) {
				return (
					<CustomTooltip title="View Cart" placement="bottom">
						<IconButton
							onClick={() => setShowCartModal(true)}
							sx={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								marginRight: '16px',
								background: '#F7F5F4',
								width: '36px',
								borderRadius: '50%',
								height: '36px',
							}}
						>
							{/*@ts-ignore*/}
							<CartItemsCount>{cartData?.cart?.length}</CartItemsCount>
							<OrderCartIcon />
						</IconButton>
					</CustomTooltip>
				);
			} else {
				return null;
			}
		} else {
			//@ts-ignore
			if (cartData?.cart?.length) {
				return (
					<CustomTooltip
						title="You do not have permission to view cart. Contact an administrator to get permission."
						placement="bottom"
					>
						<span>
							<IconButton
								onClick={() => {}}
								disabled
								sx={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									marginRight: '16px',
									background: '#F7F5F4',
									width: '36px',
									borderRadius: '50%',
									height: '36px',
								}}
							>
								{/* @ts-ignore */}
								<CartItemsCount>{cartData?.cart?.length}</CartItemsCount>
								<OrderCartIcon />
							</IconButton>
						</span>
					</CustomTooltip>
				);
			} else {
				return null;
			}
		}
	};

	const cartBtnMobileView = () => {
		if (canViewCart) {
			if (cartData) {
				return (
					<div
						onClick={() => setShowCartModal(true)}
						style={{
							position: 'relative',
						}}
					>
						{/*@ts-ignore*/}
						<CartItemsCount style={{ left: '10px', top: '-2px' }}>
							{cartData?.cart?.length}
						</CartItemsCount>
						<OrderCartIcon2 fill="#7D7D7D" />
					</div>
				);
			} else {
				return null;
			}
		} else {
			//@ts-ignore
			if (cartData?.cart?.length) {
				return (
					<CustomTooltip
						title="You do not have permission to view cart. Contact an administrator to get permission."
						placement="bottom"
					>
						<span>
							<MenuItem onClick={() => {}} disabled>
								<div style={{ position: 'relative' }}>
									{/* @ts-ignore */}
									<CartItemsCount>{cartData?.cart?.length}</CartItemsCount>
									<OrderCartIcon style={{ marginRight: '6px' }} />
								</div>
								View Cart
							</MenuItem>
						</span>
					</CustomTooltip>
				);
			} else {
				return null;
			}
		}
	};

	const dispatch = useAppDispatch();
	// const displayMenu = (event: MouseEvent) => {
	// 	if (event.currentTarget instanceof Element) {
	// 		setAnchorEl(event.currentTarget);
	// 	}
	// };

	const hideMenu = () => {
		setAnchorEl(undefined);
	};
	const displayMenu = (event: MouseEvent) => {
		setAnchorEl(event.currentTarget);
	};

	const showSearchMessages = () => {
		PubSub.publish(EVENT_TOPIC_SEARCH_MESSAGES_VISIBILITY, true);
	};

	const showContactDetails = () => {
		PubSub.publish(EVENT_TOPIC_CONTACT_DETAILS_VISIBILITY, true);
		setDrawerOpen && setDrawerOpen(false);
		dispatch(setIsDrawerOpen(false));
	};

	const showContactDetailsAndHideMenu = () => {
		showContactDetails();
		hideMenu();
	};

	const showChatAssignmentAndHideMenu = () => {
		setChatAssignmentVisible(true);
		hideMenu();
	};

	const showChatTagsAndHideMenu = () => {
		setChatTagsVisible(true);
		hideMenu();
	};

	const toggleAssignmentAndTaggingHistory = () => {
		setDisplayAssignmentAndTaggingHistory(!getDisplayAssignmentAndTaggingHistory());
		hideMenu();

		// Force refresh chat
		PubSub.publish(EVENT_TOPIC_FORCE_REFRESH_CHAT, true);
	};

	//For Mobile Screen
	useEffect(() => {
		window.addEventListener('resize', updateWindowDimensions);

		return () => {
			window.removeEventListener('resize', updateWindowDimensions);
		};
	}, []);

	useEffect(() => {
		updateWindowDimensions();
	}, []);

	return (
		<div className="chat__header" onDrop={(event) => event.preventDefault()}>
			{!isChatOnly && (
				<div className="mobileOnly">
					<IconButton className="chat__header__backButton" onClick={closeChat} size="large">
						<ArrowBack />
					</IconButton>
				</div>
			)}

			<div
				className="chat__header__clickable"
				onClick={showContactDetails}
				style={isMobileWidth ? { width: 'calc(100vw - 100px)' } : {}}
			>
				<CustomAvatar
					//@ts-ignore
					src={chat?.contact?.waba_payload?.profile?.photo}
					className={'chat__header__avatar ' + (person?.isExpired ? 'expired' : '')}
					//@ts-ignore
					generateBgColorBy={!person?.isExpired ? chat?.companyName : undefined}
				>
					{person?.initials}
				</CustomAvatar>

				<div className="chat__headerInfo">
					{/* <PrintMessage
						as="h3"
						message={
							contactProvidersData[waId]?.[0]?.name ??
							person?.name ??
							(person?.waId ? addPlus(person?.waId) : '')
						}
					/> */}
					<Typography
						//@ts-ignore
						variant="chatFont"
						style={{
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							width: '300px',
							whiteSpace: 'nowrap',
							display: 'block',
						}}
					>
						{/* @ts-ignore */}
						{chat?.companyName}
					</Typography>

					{/*<p><Moment date={contact?.lastMessageTimestamp} format={dateFormat} unix /></p>*/}

					<div className={styles.subRow}>
						<span
							className={cx({
								waId: true,
								desktopOnly: true,
							})}
						>
							{person?.waId ? person?.waId : ''}
						</span>
					</div>
				</div>
			</div>

			<div className="chat__headerRight">
				{isMobileOnly && hasFailedMessages && (
					<Tooltip title={t('Failed to send some messages!')}>
						<IconButton onClick={closeChat} size="large">
							<WarningIcon className="error" />
						</IconButton>
					</Tooltip>
				)}

				<RenderRewardAmountAvailable rewardsInfo={rewardsInfo} creditInfo={creditInfo} />

				<>
					{isMobileWidth ? (
						<IconContainer>
							{cartBtnMobileView()}
							{isRestaurant ? (
								canCreateOrderBook ? (
									<IconButton
										onClick={() => {
											setOrderBook && setOrderBook(true);
										}}
									>
										<OrderBookIcon />
									</IconButton>
								) : (
									<CustomTooltip
										title="You do not have permission to create an order book. Contact an administrator to get permission."
										placement="bottom"
									>
										<span>
											<IconButton onClick={() => {}} disabled>
												<OrderBookIcon />
											</IconButton>
										</span>
									</CustomTooltip>
								)
							) : null}
						</IconContainer>
					) : (
						<Box
							sx={{
								display: 'flex !important',
								alignItems: 'center !important',
								margin: '10px !important',
							}}
						>
							{cartIconButton()}
							{isRestaurant ? (
								canCreateOrderBook ? (
									<CustomButton
										title="Edit Order Book"
										handleClick={() => {
											setOrderBook && setOrderBook(true);
										}}
										color="secondary"
										heightVariant="medium"
										styles={{ mr: 2, height: '36px' }}
									/>
								) : (
									<CustomTooltip
										title="You do not have permission to create an order book. Contact an administrator to get permission."
										placement="bottom"
									>
										<span>
											<CustomButton
												StartIcon={<LockIconSmall stroke="#acacac" />}
												title="Edit Order Book"
												handleClick={() => {}}
												color="secondary"
												heightVariant="medium"
												styles={{ mr: 2, height: '36px' }}
												disabled
											/>
										</span>
									</CustomTooltip>
								)
							) : null}

							{orderButton()}
						</Box>
					)}
				</>
			</div>
		</div>
	);
};

export default ChatHeader;
